var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dedf5e3fc7cbff1d243ee7eabfbe60c36ad17365"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kfh-gatsby@fresh-egg-limited"]={id:"dedf5e3fc7cbff1d243ee7eabfbe60c36ad17365"};
      